import { createContext } from 'react';
import type { ILocalizationService } from '../types';

export const LocalizationContext = createContext<ILocalizationService | null>(null);
